import * as React from "react";

const SvgFeatureCheckboxUnselected = (props) => (
  <svg
    width={31}
    height={32}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.5 31.35c-4.14 0-8.032-1.612-10.96-4.54A15.398 15.398 0 0 1 0 15.85c0-4.14 1.612-8.032 4.54-10.96A15.398 15.398 0 0 1 15.5.35c4.14 0 8.032 1.612 10.96 4.54A15.398 15.398 0 0 1 31 15.85c0 4.14-1.612 8.032-4.54 10.96a15.398 15.398 0 0 1-10.96 4.54Zm0-29.45C7.807 1.9 1.55 8.158 1.55 15.85c0 7.693 6.257 13.95 13.95 13.95s13.95-6.257 13.95-13.95c0-7.692-6.257-13.95-13.95-13.95Z"
      fill="#fff"
    />
  </svg>
);

export default SvgFeatureCheckboxUnselected;
